<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5"> SERVIÇOS </span>
                <div class="float-right ml-2">
                    <span class="text-primary">
                        <i
                            class="fa fa-refresh fa-lg icon-button"
                            title="Atualizar"
                            @click.stop="obterComprometimentos()"
                        ></i>
                    </span>
                </div>
                <b-button
                    variant="danger"
                    @click.stop="voltar()"
                    class="float-right btn-sm"
                >
                    <span>
                        <i class="fa fa-history"></i> Voltar ao detalhamento do
                        contrato
                    </span>
                </b-button>
            </b-card-header>
            <b-card-body>
                <b-alert show variant="warning" v-if="contrato.tipoEspecial">
                    <h5>Atenção</h5>
                    <p>
                        Esse contrato requer documento(s) comprobatório(s)
                        anexado(s) ao serviço, para que este possa ser enviado
                        para análise.
                    </p>
                </b-alert>
                <app-tabela
                    :itens="comprometimentosFiltrados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-row class="flex-row-reverse">
                            <b-col sm="12" md="4">
                                <b-form-group>
                                    <strong>
                                        <label>Por Status</label>
                                    </strong>
                                    <b-form-select
                                        :plain="true"
                                        :options="statusSelect"
                                        v-model="status"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group>
                                    <strong>
                                        <label
                                            >Por Situação do
                                            Comprometimento</label
                                        >
                                    </strong>
                                    <b-form-select
                                        :plain="true"
                                        :options="
                                            situacoesComprometimentoSelect
                                        "
                                        v-model="situacaoComprometimento"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                            <!-- <b-col sm="12" md="4">
                                <b-form-group>
                                    <strong>
                                        <label>Por Prazo</label>
                                    </strong>
                                    <b-form-select
                                        :plain="true"
                                        :options="prazosEntregasSelect"
                                        v-model="prazoEntregas"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col> -->
                        </b-row>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                    <template slot="idRm" slot-scope="data"
                        >{{ data.idRm }}
                        <status-id-mov :comprometimento="data"></status-id-mov
                    ></template>
                    <template slot="acoes" slot-scope="data">
                        <btn-detalhar-requisicao
                            :comprometimento="data"
                        ></btn-detalhar-requisicao>
                        <comprometimento-anexos
                            :comprometimento="data"
                            :dataServico="dataServico"
                            :mostrarBtnInserir="mostrarBtnInserir(data)"
                            :mostrarBtnExcluir="mostrarBtnExcluir(data)"
                            @obter-atualizacao="obterComprometimentos()"
                        ></comprometimento-anexos>
                        <comprometimento-enviar-para-analise
                            :contrato="contrato"
                            :comprometimento="data"
                            :dataServico="dataServico"
                            @obter-atualizacao="obterComprometimentos()"
                        >
                        </comprometimento-enviar-para-analise>
                        <comprometimento-cancelar-envio-para-analise
                            :contrato="contrato"
                            :comprometimento="data"
                            :dataServico="dataServico"
                            @obter-atualizacao="obterComprometimentos()"
                        >
                        </comprometimento-cancelar-envio-para-analise>
                        <comprometimento-aprovadores
                            :comprometimento="data"
                            :dataServico="dataServico"
                        >
                        </comprometimento-aprovadores>
                        <btn-justificativas-reprovacao
                            :comprometimento="data"
                        ></btn-justificativas-reprovacao>
                        <comprometimento-time-line
                            :comprometimentosServicos="dataServico"
                            :comprometimento="data"
                        ></comprometimento-time-line>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ComprometimentoAnexos from './ComprometimentoAnexos'
import ComprometimentoEnviarParaAnalise from './ComprometimentoEnviarParaAnalise'
import ComprometimentoCancelarEnvioParaAnalise from './ComprometimentoCancelarEnvioParaAnalise'
import ComprometimentoAprovadores from './ComprometimentoAprovadores'
import { comprometimentoStatus } from './ComprometimentoStatus'
import { comprometimentoSituacao } from './ComprometimentoSituacao'
import BtnJustificativasReprovacao from './BtnJustificativasReprovacao'
import BtnDetalharRequisicao from '../requisicoes/BtnDetalharRequisicao'
import StatusIdMov from './StatusIdMov.vue'
import ComprometimentoTimeLine from './ComprometimentoTimeLine'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            statusSelect: [
                { text: 'TODOS', value: -2 },
                { text: 'EM ABERTO', value: 0 },
                { text: 'EM ANÁLISE', value: 1 },
                { text: 'APROVADA', value: 2 },
                { text: 'REPROVADA', value: 3 }
            ],
            status: -2,
            situacoesComprometimentoSelect: [
                { text: 'TODOS', value: -2 },
                { text: 'COMPROMETIDO', value: 0 },
                { text: 'NÃO COMPROMETIDO', value: 1 }
            ],
            situacaoComprometimento: 0,
            comprometimentos: [],
            // comprometimentosFiltrados: [],
            erros: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-center'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap',
                    type: 'status'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        voltar() {
            if (this.$route.name == 'FornecedoresContratos_Comprometimentos') {
                this.$router.push({ name: 'FornecedoresContratos_Detalhar' })
            } else {
                this.$router.push({ name: 'FornecedorContratos_Detalhar' })
            }
        },

        obterComprometimentos() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.$route.name === 'FornecedoresContratos_Comprometimentos') {
                promisse = this.dataServico.obterComprometimentos(
                    this.$route.params.fornecedorId,
                    this.$route.params.codContrato
                )
            } else {
                promisse = this.dataServico.obterComprometimentos(
                    this.$route.params.codContrato
                )
            }
            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        this.comprometimentos = response.data
                    } else {
                        this.erros = ['Erro ao obter serviços']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        mostrarBtnInserir(comprometimento) {
            return (
                (comprometimento.status == comprometimentoStatus.EM_ABERTO ||
                    comprometimento.status ==
                        comprometimentoStatus.REPROVADA) &&
                this.$temAcessoView('FORN-CONTRATOS-00')
            )
        },

        mostrarBtnExcluir(comprometimento) {
            return (
                (comprometimento.status == comprometimentoStatus.EM_ABERTO ||
                    comprometimento.status ==
                        comprometimentoStatus.REPROVADA) &&
                this.$temAcessoView('FORN-CONTRATOS-00')
            )
        }
    },

    created() {
        this.obterComprometimentos()
    },

    computed: {
        comprometimentosFiltrados() {
            if (this.status == -2 && this.situacaoComprometimento == -2) {
                return [...this.comprometimentos]
            } else if (
                this.status != -2 &&
                this.situacaoComprometimento == -2
            ) {
                return this.comprometimentos.filter(
                    (p) => p.status == this.status
                )
            } else if (
                this.status == -2 &&
                this.situacaoComprometimento != -2
            ) {
                if (this.situacaoComprometimento == 0) {
                    return this.comprometimentos.filter(
                        (p) =>
                            p.idSituacao ==
                                comprometimentoSituacao.COMPROMETIDO_COM_SUCESSO ||
                            p.idSituacao ==
                                comprometimentoSituacao.VINCULADO_A_UM_PAGAMENTO
                    )
                } else {
                    return this.comprometimentos.filter(
                        (p) =>
                            p.idSituacao !=
                                comprometimentoSituacao.COMPROMETIDO_COM_SUCESSO &&
                            p.idSituacao !=
                                comprometimentoSituacao.VINCULADO_A_UM_PAGAMENTO
                    )
                }
            } else if (
                this.status != -2 &&
                this.situacaoComprometimento != -2
            ) {
                if (this.situacaoComprometimento == 0) {
                    return this.comprometimentos.filter(
                        (p) =>
                            p.status == this.status &&
                            (p.idSituacao ==
                                comprometimentoSituacao.COMPROMETIDO_COM_SUCESSO ||
                                p.idSituacao ==
                                    comprometimentoSituacao.VINCULADO_A_UM_PAGAMENTO)
                    )
                } else {
                    return this.comprometimentos.filter(
                        (p) =>
                            p.status == this.status &&
                            p.idSituacao !=
                                comprometimentoSituacao.COMPROMETIDO_COM_SUCESSO &&
                            p.idSituacao !=
                                comprometimentoSituacao.VINCULADO_A_UM_PAGAMENTO
                    )
                }
            }
        }
    },

    watch: {},

    components: {
        ComprometimentoAnexos,
        ComprometimentoEnviarParaAnalise,
        ComprometimentoAprovadores,
        BtnJustificativasReprovacao,
        ComprometimentoCancelarEnvioParaAnalise,
        BtnDetalharRequisicao,
        StatusIdMov,
        ComprometimentoTimeLine
    }
}
</script>
